import { CastorMapper } from './mapper';
import { RangeFacetParams } from '@aipb/gulliver/castor/model';

export class RangeFacetMapper implements CastorMapper<RangeFacetParams> {
  map(o: RangeFacetParams): { [p: string]: any } {
    if (!o) return {};

    const obj = {};

    obj['range.start'] = o.start;
    delete o['start'];

    obj['range.end'] = o.end;
    delete o['end'];

    obj['range.gap'] = o.gap;
    delete o['gap'];

    if ('otherAll' in o) {
      obj['other.all'] = o.otherAll;
      delete o['otherAll'];
    }

    return {
      ...o,
      ...obj
    };
  }
}

export const RANGE_FACET_MAPPER = new RangeFacetMapper();
